import React, { lazy, Suspense } from "react";
import {
    Route,
    Routes,
    BrowserRouter,
    Navigate,
    Outlet,
    useLocation,
} from "react-router-dom";

import Application from "../components/pages/Application";
import { PublicRoute, PrivateRoute } from "./RouteTypes";
import UiRoutes from "./UiRoutes";
import ScrollToTop from "../components/common/ScrollToTop";
import { SuspenseLoading } from "../components/_uiComponents/common/UiLoadingSpinner";
// import ProductTargetIncentives from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentives";
// import ProductTargetIncentivesTwo from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesTwo";
// import LeagueIncentivesCastrol from "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesCastrol";
// import LeagueIncentives from "../components/_uiMocks/pages/incentives/custom/LeagueIncentives";
// import ProductTargetIncentivesQ4 from "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesQ4";
// import LeagueIncentivesQ4Castrol from "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Castrol";
// import LeagueIncentivesQ4Winter from "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Winter";
import OtpWrapper from "../components/pages/auth/OtpWrapper";
import ForgotPasswordWrapper from "../components/pages/auth/ForgotPasswordWrapper";
import ResetPasswordWrapper from "../components/pages/auth/ResetPasswordWrapper";
import SignUpWrapper from "../components/pages/auth/SignUpWrapper";
import { useSelector } from "react-redux";

const IncentiveRenaultWrapper = lazy(() =>
    import("../components/pages/incentive/IncentiveRenaultWrapper"),
);
const IncentiveDetails = lazy(() =>
    import("../components/pages/incentive/IncentiveDetails"),
);

const ProductTargetIncentives = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentives"
    ),
);

const ProductTargetIncentivesTwo = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesTwo"
    ),
);

const LeagueIncentivesCastrol = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesCastrol"
    ),
);

const LeagueIncentivesQ4Castrol = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Castrol"
    ),
);

const ProductTargetIncentivesQ4 = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/ProductTargetIncentivesQ4"
    ),
);

const LeagueIncentivesQ4Winter = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4Winter"
    ),
);

const IncentivesBanded = lazy(() =>
    import("../components/_uiMocks/pages/incentives/custom/IncentivesBanded"),
);

const CastrolSpinWin = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CastrolSpinWin"
    ),
);

const LeagueIncentivesQ4 = lazy(() =>
    import("../components/_uiMocks/pages/incentives/custom/LeagueIncentivesQ4"),
);

const IncentivesBandedNovember = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/IncentivesBandedNovember"
    ),
);

const IncentivesBandedDecember = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedDecember"
    ),
);

const IncentivesBandedJanuary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedJanuary"
    ),
);

const IncentivesBandedFebruary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedFebruary"
    ),
);

const IncentivesBandedMarch = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedMarch"
    ),
);

const IncentivesBandedApril = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedApril"
    ),
);

const IncentivesBandedMay = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/tlc/IncentivesBandedMay"
    ),
);

const AlpineCustomerExcellence = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/AlpineCustomerExcellence"
    ),
);

const TradePartsManagerIncentive = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/TradePartsManagerIncentive"
    ),
);

const AbuDhabiWinnersHome = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiWinnersHome"
    ),
);

const AbuDhabiDayOne = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayOne"
    ),
);

const AbuDhabiDayTwo = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayTwo"
    ),
);

const AbuDhabiDayThree = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayThree"
    ),
);

const AbuDhabiDayFour = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/abu-dhabi-winners/AbuDhabiDayFour"
    ),
);

const RenaultHomeWrapper = lazy(() =>
    import("../components/pages/home-renault/RenaultHomeWrapper"),
);

const KnowlegeWrapper = lazy(() =>
    import("../components/pages/learn/KnowlegeWrapper"),
);

const ShopWrapper = lazy(() => import("../components/pages/shop/ShopWrapper"));
const VoucherDetails = lazy(() =>
    import("../components/pages/shop/VoucherDetails"),
);

const RebateVoucherDetails = lazy(() =>
    import("../components/pages/shop/RebateVoucherDetails"),
);

const OrderConfirmation = lazy(() =>
    import("../components/pages/shop/OrderConfirmation"),
);

const VoucherWallet = lazy(() =>
    import("../components/pages/shop/VoucherWallet"),
);

const BrowseProducts = lazy(() =>
    import("../components/pages/shop/BrowseProducts"),
);

const OrderDetails = lazy(() =>
    import("../components/pages/shop/OrderDetails"),
);

const PointsBankingWrapper = lazy(() =>
    import("../components/pages/points-bankings-renault/PointsBankingWrapper"),
);

const RenaultPointsBankingWrapper = lazy(() =>
    import("../components/pages/points-bankings-renault/PointsBankingWrapper"),
);

const AllQuizzers = lazy(() => import("../components/pages/learn/AllQuizzers"));

const QuizHome = lazy(() => import("../components/pages/learn/QuizHome"));

const CommsPage = lazy(() =>
    import("../components/_uiMocks/pages/CommsPage/CommsPage"),
);

const CommsPageOne = lazy(() =>
    import("../components/pages/comms-templates/CommsPageOne"),
);

const CommsPageTwo = lazy(() =>
    import("../components/pages/comms-templates/CommsPageTwo"),
);

const CommsPageThree = lazy(() =>
    import("../components/pages/comms-templates/CommsPageThree"),
);

const CommsPageFour = lazy(() =>
    import("../components/pages/comms-templates/CommsPageFour"),
);

const CommsWrapper = lazy(() =>
    import("../components/pages/comms-templates/CommsWrapper"),
);

const CommsPageFive = lazy(() =>
    import("../components/pages/comms-templates/CommsPageFive"),
);

const CommsPageSix = lazy(() =>
    import("../components/pages/comms-templates/CommsPageSix"),
);

const CommsPageSeven = lazy(() =>
    import("../components/pages/comms-templates/CommsPageSeven"),
);

const CommsPageEight = lazy(() =>
    import("../components/pages/comms-templates/CommsPageAbuDhabiIncetive"),
);

const CommsPageMotrio = lazy(() =>
    import("../components/pages/comms-templates/CommsPageMotrio"),
);

const ServiceStars2025 = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ServiceStars2025"
    ),
);

const CastrolMotoGp = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/CastrolMotoGp"
    ),
);

const MyBasket = lazy(() => import("../components/pages/shop/MyBasket"));

const ProductTargetIncentivesJanuary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ProductTargetIncentivesJanuary"
    ),
);

const ProductTargetIncentivesFebruary = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/ProductTargetIncentivesFebruary"
    ),
);

const MarchGoldenTickets = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/MarchGoldenTickets"
    ),
);

const IncentiveWearAndTear = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/IncentiveWearAndTear"
    ),
);
const QtwoWearAndTear = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/QtwoWearAndTear"
    ),
);
const TradePartsManagerTlcView = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/TradePartsManagerTlcView"
    ),
);

const FullThrottle = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/FullThrottle"
    ),
);

const MayGoldenTicket = lazy(() =>
    import(
        "../components/_uiMocks/pages/incentives/custom/equipe/MayGoldenTicket"
    ),
);

import {
    participantJobRoleIds,
    contextApiActions,
    participantTypeIds,
} from "../_redux/_constants";
import RedirectRoutes from "./RedirectRouters";

export default function MainRoutes() {
    const { userProfileDetails } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
        };
    });

    const visibleCustomerId = [
        2000038, 2000110, 2000152, 2000599, 2000319, 2000085, 2000382, 2000164,
        2000104, 2000069, 2000035, 2000034, 1000001, 2000588, 2000670, 2000669,
    ];
    const alpineVisibleCustomerId = [
        2000071, 2000107, 2000072, 2000093, 2000601, 2000120, 2000319, 2000130,
        2000073, 2000112, 2000647, 2000178, 2000105, 2000069, 2000068, 2000109,
        2000038, 2000035, 2000034, 1000001, 2000588, 2000673, 2000674, 2000671,
    ];

    return (
        <ScrollToTop>
            <Routes>
                {/* Public routes */}
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <Application />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/auth/*"
                    element={
                        <>
                            <Outlet />
                        </>
                    }
                >
                    <Route
                        path="otp-verification/:id/:userId"
                        element={
                            <PublicRoute>
                                <OtpWrapper />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="forgot-password"
                        element={
                            <PublicRoute>
                                <ForgotPasswordWrapper />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="set-password"
                        element={
                            <PublicRoute>
                                <ResetPasswordWrapper />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path="sign-up"
                        element={
                            <PublicRoute>
                                <SignUpWrapper />
                            </PublicRoute>
                        }
                    />
                </Route>

                {/* <Route
                    path="/:id"
                    element={
                        <PublicRoute>
                            <Suspense fallback={<SuspenseLoading />}>
                                <SignUpWrapper />
                            </Suspense>
                        </PublicRoute>
                    }
                /> */}

                {/* Public routes */}
                {/* Private routes */}

                <Route path="/app/*" element={<PrivateRoute />}>
                    <Route path="home" element={<RenaultHomeWrapper />} />
                    {/* <Route path="home-renault" element={<RenaultHomeWrapper />} /> */}
                    <Route
                        path="campaigns"
                        element={<IncentiveRenaultWrapper />}
                    />

                    {(userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER ||
                        userProfileDetails?.jobRoleId ==
                            participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER || 
                             userProfileDetails?.jobRoleId ==
                            participantJobRoleIds.TLC_TRADE_REP) &&
                        participantTypeIds.TLC_PARTICIPANT ==
                            userProfileDetails?.roleId && (
                            <>
                                <Route
                                    path="campaigns/260"
                                    element={<IncentivesBanded />}
                                />
                                <Route
                                    path="campaigns/265"
                                    element={<IncentivesBandedNovember />}
                                />
                                <Route
                                    path="campaigns/266"
                                    element={<IncentivesBandedDecember />}
                                />
                                <Route
                                    path="campaigns/268"
                                    element={<IncentivesBandedJanuary />}
                                />
                                <Route
                                    path="campaigns/275"
                                    element={<IncentivesBandedFebruary />}
                                />

                                <Route
                                    path="campaigns/276"
                                    element={<IncentivesBandedMarch />}
                                />

                                <Route
                                    path="campaigns/282"
                                    element={<IncentivesBandedApril />}
                                />
                                 <Route
                                    path="campaigns/283"
                                    element={<IncentivesBandedMay />}
                                />
                            </>
                        )}

                    {userProfileDetails?.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                    participantTypeIds.PARTICIPANT ==
                        userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/318"
                                element={<QtwoWearAndTear />}
                            />
                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />

                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />

                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />

                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            />
                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />
                            {/* <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            /> */}

                            {visibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/325"
                                        element={<AbuDhabiWinnersHome />}
                                    />
                                    <Route
                                        path="campaigns/winners/day-01"
                                        element={<AbuDhabiDayOne />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-02"
                                        element={<AbuDhabiDayTwo />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-03"
                                        element={<AbuDhabiDayThree />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-04"
                                        element={<AbuDhabiDayFour />}
                                    />
                                </>
                            )}
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <Route
                                    path="campaigns/130"
                                    element={<AlpineCustomerExcellence />}
                                />
                            )}
                        </>
                    ) : userProfileDetails?.jobRoleId ==
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/360"
                                element={<MayGoldenTicket />}
                            />
                            <Route
                                path="campaigns/282"
                                element={<IncentivesBandedApril />}
                            />
                            <Route
                                path="campaigns/300"
                                element={<LeagueIncentivesQ4 />}
                            />

                            <Route
                                path="campaigns/318"
                                element={<QtwoWearAndTear />}
                            />

                            <Route
                                path="campaigns/350"
                                element={<LeagueIncentivesQ4Winter />}
                            />
                            <Route
                                path="campaigns/320"
                                element={<LeagueIncentivesQ4Castrol />}
                            />
                            <Route
                                path="campaigns/280"
                                element={<LeagueIncentivesCastrol />}
                            />
                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />

                            <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            />
                            {/* <Route
                                path="campaigns/317"
                                element={<MarchGoldenTickets />}
                            ></Route> */}
                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />
                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            <Route
                                path="campaigns/128"
                                element={<ServiceStars2025 />}
                            />

                            <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            />

                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <Route
                                    path="campaigns/130"
                                    element={<AlpineCustomerExcellence />}
                                />
                            )}

                            {/* <Route 
                                    path="campaigns/winners/day-01"
                                    element={<AbuDhabiDayOne/>}/>

                                <Route 
                                    path="campaigns/winners/day-02"
                                    element={<AbuDhabiDayTwo/>}/>

                                <Route 
                                    path="campaigns/winners/day-03"
                                    element={<AbuDhabiDayThree/>}/>

                                <Route 
                                    path="campaigns/winners/day-04"
                                    element={<AbuDhabiDayFour/>}/> */}

                            {visibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/325"
                                        element={<AbuDhabiWinnersHome />}
                                    />
                                    <Route
                                        path="campaigns/winners/day-01"
                                        element={<AbuDhabiDayOne />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-02"
                                        element={<AbuDhabiDayTwo />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-03"
                                        element={<AbuDhabiDayThree />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-04"
                                        element={<AbuDhabiDayFour />}
                                    />
                                </>
                            )}
                        </>
                    ) : userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/360"
                                element={<MayGoldenTicket />}
                            />
                            <Route
                                path="campaigns/330"
                                element={<FullThrottle />}
                            />

                            <Route
                                path="campaigns/300"
                                element={<LeagueIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            {visibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <>
                                    <Route
                                        path="campaigns/325"
                                        element={<AbuDhabiWinnersHome />}
                                    />
                                    <Route
                                        path="campaigns/winners/day-01"
                                        element={<AbuDhabiDayOne />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-02"
                                        element={<AbuDhabiDayTwo />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-03"
                                        element={<AbuDhabiDayThree />}
                                    />

                                    <Route
                                        path="campaigns/winners/day-04"
                                        element={<AbuDhabiDayFour />}
                                    />
                                </>
                            )}
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <Route
                                    path="campaigns/130"
                                    element={<AlpineCustomerExcellence />}
                                />
                            )}
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />

                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />

                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />

                            <Route
                                path="campaigns/350"
                                element={<LeagueIncentivesQ4Winter />}
                            />
                            <Route
                                path="campaigns/320"
                                element={<LeagueIncentivesQ4Castrol />}
                            />
                            <Route
                                path="campaigns/280"
                                element={<LeagueIncentivesCastrol />}
                            />
                            <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            />
                            <Route
                                path="campaigns/128"
                                element={<ServiceStars2025 />}
                            />

                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />

                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />

                            <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            />
                            <Route
                                path="campaigns/318"
                                element={<QtwoWearAndTear />}
                            />
                            {/* <Route
                                path="campaigns/317"
                                element={<MarchGoldenTickets />}
                            /> */}

                            <Route
                                path="campaigns/314"
                                element={<TradePartsManagerIncentive />}
                            />
                            <Route
                                path="campaigns/278"
                                element={<TradePartsManagerTlcView />}
                            />

                            {userProfileDetails?.area === "0" && (
                                <>
                                    <Route
                                        path="campaigns/314"
                                        element={<TradePartsManagerIncentive />}
                                    />
                                    {/* <Route
                                        path="campaigns/317"
                                        element={<MarchGoldenTickets />}
                                    /> */}
                                    <Route
                                        path="campaigns/316"
                                        element={<CastrolMotoGp />}
                                    />
                                    <Route
                                        path="campaigns/318"
                                        element={<QtwoWearAndTear />}
                                    />
                                    <Route
                                        path="campaigns/278"
                                        element={<TradePartsManagerTlcView />}
                                    />
                                    <Route
                                        path="campaigns/360"
                                        element={<MayGoldenTicket />}
                                    />
                                </>
                            )}
                        </>
                    ) : userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/360"
                                element={<MayGoldenTicket />}
                            />
                            <Route
                                path="campaigns/300"
                                element={<LeagueIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/290"
                                element={<ProductTargetIncentives />}
                            />
                            <Route
                                path="campaigns/314"
                                element={<TradePartsManagerIncentive />}
                            />
                            {/* <Route
                                path="campaigns/317"
                                element={<MarchGoldenTickets />}
                            /> */}
                            <Route
                                path="campaigns/270"
                                element={<ProductTargetIncentivesTwo />}
                            />
                            <Route
                                path="campaigns/310"
                                element={<ProductTargetIncentivesQ4 />}
                            />
                            <Route
                                path="campaigns/312"
                                element={<ProductTargetIncentivesJanuary />}
                            />
                            <Route
                                path="campaigns/350"
                                element={<LeagueIncentivesQ4Winter />}
                            />
                            <Route
                                path="campaigns/320"
                                element={<LeagueIncentivesQ4Castrol />}
                            />
                            <Route
                                path="campaigns/260"
                                element={<IncentivesBanded />}
                            />
                            <Route
                                path="campaigns/280"
                                element={<LeagueIncentivesCastrol />}
                            />
                            <Route
                                path="campaigns/125"
                                element={<CastrolSpinWin />}
                            />
                            <Route
                                path="campaigns/125/:id"
                                element={<CastrolSpinWin />}
                            />
                            <Route
                                path="campaigns/128"
                                element={<ServiceStars2025 />}
                            />
                            <Route
                                path="campaigns/325"
                                element={<AbuDhabiWinnersHome />}
                            />
                            <Route
                                path="campaigns/318"
                                element={<QtwoWearAndTear />}
                            />
                            {alpineVisibleCustomerId?.includes(
                                userProfileDetails?.userId,
                            ) && (
                                <Route
                                    path="campaigns/130"
                                    element={<AlpineCustomerExcellence />}
                                />
                            )}
                            <Route
                                path="campaigns/313"
                                element={<ProductTargetIncentivesFebruary />}
                            />
                            <Route
                                path="campaigns/316"
                                element={<CastrolMotoGp />}
                            />
                            <Route
                                path="campaigns/315"
                                element={<IncentiveWearAndTear />}
                            />
                            <Route
                                path="campaigns/330"
                                element={<FullThrottle />}
                            />
                            <Route
                                path="campaigns/278"
                                element={<TradePartsManagerTlcView />}
                            />
                            <Route
                                path="campaigns/360"
                                element={<MayGoldenTicket />}
                            />
                        </>
                    ) : userProfileDetails?.jobRoleId ===
                          participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER &&
                      participantTypeIds.PARTICIPANT ==
                          userProfileDetails?.roleId ? (
                        <>
                            <Route
                                path="campaigns/314"
                                element={<TradePartsManagerIncentive />}
                            />

                            <Route
                                path="campaigns/278"
                                element={<TradePartsManagerTlcView />}
                            />
                            <Route
                                path="campaigns/330"
                                element={<FullThrottle />}
                            />
                        </>
                    ) : (
                        ""
                    )}
                    <Route
                        path="campaigns/comms-page"
                        element={<CommsPage />}
                    />

                    <Route path="learn" element={<KnowlegeWrapper />} />
                    <Route
                        path="learn/all-quizzers"
                        element={<AllQuizzers />}
                    />
                    <Route path="learn/:id" element={<QuizHome />} />
                    <Route path="shop" element={<ShopWrapper />} />
                    <Route path="shop/:id" element={<VoucherDetails />} />
                    <Route
                        path="shop/rebate-voucher"
                        element={<RebateVoucherDetails />}
                    />
                    <Route
                        path="shop/browse-products"
                        element={<BrowseProducts />}
                    />

                    <Route
                        path="shop/confirm-order"
                        element={<OrderConfirmation />}
                    />
                    <Route
                        path="shop/voucher-wallet"
                        element={<VoucherWallet />}
                    />
                    <Route
                        path="shop/order-details/:id"
                        element={<OrderDetails />}
                    />

                    <Route
                        path="points-banking"
                        element={<RenaultPointsBankingWrapper />}
                    />
                    {/* <Route
                        path="renault-points-banking"
                        element={<RenaultPointsBankingWrapper />}
                    /> */}

                    <Route
                        path="campaigns/comms/1"
                        element={<CommsPageOne />}
                    />
                    <Route
                        path="campaigns/comms/2"
                        element={<CommsPageTwo />}
                    />
                    <Route path="comms-page-03" element={<CommsPageThree />} />
                    <Route path="comms-page-04" element={<CommsPageFour />} />
                    <Route
                        path="campaigns/comms/5"
                        element={<CommsPageFive />}
                    />
                    <Route
                        path="campaigns/comms/6"
                        element={<CommsPageSix />}
                    />

                    <Route
                        path="campaigns/comms/7"
                        element={<CommsPageSeven />}
                    />

                    <Route
                        path="campaigns/comms/8"
                        element={<CommsPageEight />}
                    />

                    <Route
                        path="campaigns/comms/32"
                        element={<CommsPageMotrio />}
                    />

                    <Route path="shop/my-basket" element={<MyBasket />} />
                    <Route path="*" element={<Navigate to="/app/home" />} />
                </Route>

                {RedirectRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                    />
                ))}
                {/* Private routes */}
                <Route path="/ui/*" element={<UiRoutes />} />

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </ScrollToTop>
    );
}
